
import { Component, Vue } from "vue-property-decorator";
import IconDeposit from "@/components/common/icon/IconDeposit.vue";

@Component({
  name: "reports-header",
  components: {
    IconDeposit,
  },
})
export default class DepositsHeader extends Vue {}
